module.exports = __webpack_public_path__ + "static/media/registry_publish_champagne.ad4b8808.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/registry_publish_champagne.svg
 ** module id = 2108
 ** module chunks = 44
 **/